import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RoadmapItemModel } from '../../services/learning-roadmap.service';

@Component({
  selector: 'tangram-roadmap-item',
  templateUrl: './roadmap-item.component.html',
  styleUrls: ['./roadmap-item.component.scss']
})
export class RoadmapItemComponent {
  @Input() item: RoadmapItemModel;
  @Output() itemChange = new EventEmitter<RoadmapItemModel>();

  onHoursChange(value: string): void {
    const nextHours = Number(value);
    this.itemChange.emit({
      ...this.item,
      recommendedHours: Number.isNaN(nextHours) ? this.item.recommendedHours : nextHours
    });
  }

  onDeadlineChange(value: string): void {
    this.itemChange.emit({
      ...this.item,
      deadline: value || this.item.deadline
    });
  }
}
